module.exports = __webpack_public_path__ + "img/anne_s.d4ec3062.png";